import { render } from "./PagerList.vue?vue&type=template&id=b3c48fae"
import script from "./PagerList.vue?vue&type=script&lang=js"
export * from "./PagerList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__